import { render, staticRenderFns } from "./CourseCheckBoxes.vue?vue&type=template&id=57c2bd48"
import script from "./CourseCheckBoxes.vue?vue&type=script&lang=ts"
export * from "./CourseCheckBoxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports